import * as fromDatatype from '../datatype-library/index';

export class app_psnl_menu_set_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  obj_sort_method: fromDatatype.VarcharDatatypeInterface;
  obj_sort_code: fromDatatype.VarcharDatatypeInterface;
  name_full: fromDatatype.VarcharDatatypeInterface;
  name_short: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  property_json: any;
  acl_config: any;
  acl_policy: any;
  layout_json: any;
}

export class app_psnl_menu_set_hdr_RowClass implements app_psnl_menu_set_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  obj_sort_method: fromDatatype.VarcharDatatypeInterface;
  obj_sort_code: fromDatatype.VarcharDatatypeInterface;
  name_full: fromDatatype.VarcharDatatypeInterface;
  name_short: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  property_json: any;
  acl_config: any;
  acl_policy: any;
  layout_json: any;
}